import { type AreaMeasurementUnit } from '@myre/app-am-generated/types/AreaMeasurementUnit';
import { type Currency } from '@myre/app-am-generated/types/Currency';
import { type ISelectItem } from '@myre/ui-primitive-forms';

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { type RootState } from '../core.module';

import {
  CORE_ACTION_GET_INDUSTRIES_SUCCESS,
  getAreaMeasurementUnitsSuccess,
  getCurrenciesSuccess,
  type GetIndustriesSuccess,
} from './core.actions';
import { type Action, type DataState } from './interfaces';

export const initialDataState: DataState = {
  industries: [],
  currencies: [],
  areaMeasurementUnits: [],
};

export const dataSelector = createFeatureSelector<RootState, DataState>('data');

export const industryOptionsSelector = createSelector(dataSelector, s =>
  s.industries.map<ISelectItem<number>>(({ id, label }) => ({
    label,
    value: id,
  })),
);

export const currencyOptionsSelector = createSelector(dataSelector, s =>
  s.currencies.map<ISelectItem<number>>(({ id, code }) => ({
    value: id,
    label: code,
  })),
);

export const areaMeasurementUnitOptionsSelector = createSelector(
  dataSelector,
  s =>
    s.areaMeasurementUnits.map<ISelectItem<number>>(({ id, code }) => ({
      value: id,
      label: code,
    })),
);

export function dataReducer(
  state: DataState = initialDataState,
  action: Action,
): DataState {
  switch (action.type) {
    case CORE_ACTION_GET_INDUSTRIES_SUCCESS: {
      const castedAction = action as GetIndustriesSuccess;

      return {
        ...state,
        industries: castedAction.industries,
      };
    }
    case getCurrenciesSuccess.type: {
      const castedAction = action as unknown as {
        currencies: readonly Currency[];
      };

      return {
        ...state,
        currencies: castedAction.currencies,
      };
    }
    case getAreaMeasurementUnitsSuccess.type: {
      const castedAction = action as unknown as {
        areaMeasurementUnits: readonly AreaMeasurementUnit[];
      };

      return {
        ...state,
        areaMeasurementUnits: castedAction.areaMeasurementUnits,
      };
    }
    default: {
      return state;
    }
  }
}
